import styled from '@emotion/styled';
import { Button } from '@mui/material';

export const ButtonStyled = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'selectedItem',
})(({ theme }) => ({
  position: 'absolute',
  bottom: 0,
  right: 0,
  borderRadius: '5px 0',
  width: 48,
  minWidth: 48,
  height: 24,
  border: `solid 1px ${theme.palette.colors.mainFocused}`,
  color: theme.palette.colors.onIconsAndTextButtonsVariant,
  backgroundColor: theme.palette.colors.mainFocused,
  '&:hover': {
    backgroundColor: theme.palette.colors.highlight,
    border: `solid 1px ${theme.palette.colors.highlight}`,
  },
}));
